module.exports = __webpack_public_path__ + "img/hefei.c873992f.png";